// extracted by mini-css-extract-plugin
module.exports = {"discountSection":"az_CMc","cart":"az_DMc","discountSectionWCorePrice":"az_EMc","strikeprice":"az_FMc","discount":"az_GMc","alignRightStrikethrough":"az_HMc"};